import {
  InputTextareaProps,
  InputTextarea as OriginalInputTextarea,
} from '@agro1desenvolvimento/react-components';
import { classNames } from 'primereact/utils';
import WithController from '../with-controller';
import InputEnhancements, { FormInputEnhancements } from './input-enhancements';

const InputTextarea = WithController<PropTypes, string>(
  ({
    className,
    field,
    fieldState,
    formState: _formState,
    addonRight,
    addonLeft,
    label,
    withErrorMessage,
    containerClassName,
    triggerDependencies,
    ...props
  }) => (
    <InputEnhancements
      addonRight={addonRight}
      addonLeft={addonLeft}
      label={label}
      withErrorMessage={withErrorMessage}
      containerClassName={containerClassName}
      field={field}
      fieldState={fieldState}
    >
      <OriginalInputTextarea
        disabled={field.disabled}
        {...props}
        name={field.name}
        onBlur={field.onBlur}
        onChange={(event) => {
          field.onChange(event);
          triggerDependencies();
        }}
        ref={field.ref}
        value={field.value}
        id={field.name}
        className={classNames({ 'p-invalid': fieldState.error }, className)}
      />
    </InputEnhancements>
  ),
);

type OmittedProps = 'id' | 'ref' | 'value' | 'onBlur' | 'onChange';

type PropTypes = Omit<InputTextareaProps, OmittedProps> & FormInputEnhancements;

export default InputTextarea;
